export default __webpack_public_path__ + "static/media/water-softener-salt-500x500.1998d5b8.jpg";